export enum AvailableEventUsersFilters {
  departmentId = 'departmentId',
  regionId = 'regionId',
  cityId = 'cityId',
  timeslotId = 'timeslotId',
  email = 'email',
  status = 'status',
  page = 'page',
}
